// @flow

import ko from 'rgs-knockout';

import { filesToFromJSExtend } from 'ko-extender-to-from-js-files';
import type { ObservableFileArray } from 'rgs-knockout';

export function observableJSableFilesArray (...args): ObservableFileArray {
	return ko.observableArray(...args)
		.extend({ toFromJS: true })
		.extend(filesToFromJSExtend);
}

